/*
 * @Author: hujingyang
 * @Description: 弹窗-人群选择-列表
 * @LastEditors: yang chenglin
 */


import React, { useEffect, useState } from 'react';
import { DatePicker, Dialog, Form, Input, Table, Button } from '@alifd/next';
import style from './index.module.scss';
import moment from 'moment';
import LzPagination from '@/components/common/LzPagination';
import utils from '@/common/utils';
import { useHistory } from 'react-router-dom';
import { Servlets } from '@/service';

// 查询参数：人群类型下拉列表
const corwdType = [
  { value: 1, label: '官方标签筛选' },
  // { value: 2, label: '手机号上传' },
  { value: 3, label: '官方推荐人群' },
  { value: 4, label: '云鹿标签筛选' },
  { value: 5, label: '官方标签筛选（新）' },
  { value: 6, label: '云鹿转官方人群' },
  { value: 7, label: '订单号生成云鹿人群' },
  { value: 8, label: '订单号生成官方人群' },
  { value: 9, label: '手机号生成官方人群' },
  { value: 10, label: '抖店openid生成官方人群' },
];

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
/** 弹窗-人群选择-列表 getDYCrowdList */
const Dialog_CrowdSelected_List = (props: any): JSX.Element => {
  const [currentType, setCurrentType] = useState(props?.type ?? '1,2,3,4,5');// 当前人群类型
  const history = useHistory();
  const [visible, setVisible] = useState(false);// 是否打开弹窗 - 人群选择
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [dataSource, setDataSource] = useState([] as object[]);// 列表数据
  const [columns, setColumns] = useState([{}]);// 列表title
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 50 }); // 分页数据
  const [searchFormData, setSearchFormData] = useState({ createTime: [], name: '' });// 搜索表单数据集合

  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, [props]);

  /** 初始化函数
   *
   */
  const init = (): void => {
    setVisible(props.visible);

    if (props.visible) {
      getPageData();
    }
  };
  /** 获取页面 */
  const getPageData = (): void => {
    setColumns(getColumns());
    getListData({pageNo: 1, pageSize: 10});
  };

  /** 关闭弹窗触发 */
  const onClose = (): void => {
    setSearchFormData({
      createTime: [],
      name: '',
    });
    setVisible(false);
    props.selected({}, false);
  };

  /**
   * 获取列表数据 配置项
   */
  const getColumns = (): object[] => {
    // 列表数据格式配置项
    const columns = [

      {
        title: '人群名称',
        dataIndex: 'name',
        width: 166,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <span>{value || '/'}</span>;
        },
      },
      {
        title: '人群描述',
        dataIndex: 'description',
        width: 166,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <span>{value || '/'}</span>;
        },
      },
      {
        title: '人群类型',
        dataIndex: 'type',
        width: 166,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <span>{corwdType.find((item) => item.value === record.type)?.label}</span>;
        },
      },
      {
        title: '人群总数',
        dataIndex: 'size',
        width: 166,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <span>{utils.numFormat_hjy(value)}</span>;
        },
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 166,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <span>{moment(value).format('YYYY-MM-DD HH:mm:ss')}</span>;
        },
      },
      {
        title: '操作',
        lock: 'right',
        width: 166,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<span
            style={{ color: '#39f', userSelect: 'none', cursor: 'pointer' }}
            onClick={() => {
              props.selected(record, true);
            }}
          >选择
                  </span>);
        },
      },

    ];
    return columns;
  };

  /** 获取列表数据 */
  const getListData = (searchForm = { pageNo: 1, pageSize: 10 }): void => {
    setLoadingForList(true);
    // 获取订单筛选列表数据
    Servlets('getDYCrowdList', { ...searchForm,crowdStatus:1, type: currentType }, true)
      .then((res: { data: []; page: { pageNo: number; pageSize: number; total: number } }) => {
        setLoadingForList(false);// 关闭loading

        setDataSource(res.data ? res.data : []); // 获取列表数据

        setPageInfo(res.page ? res.page : pageInfo);// 设置分页
      })
      .catch((err) => {
        console.log(err);
        setLoadingForList(false);
      });
  };
  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = { pageSize: 10, pageNo: 1 }): Promise<void> => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });

      const searchForm = {
        startTime: searchFormData.createTime[0] ? `${moment(searchFormData.createTime[0] as any * 1000).unix()}` : '', // 创建时间 起始
        endTime: searchFormData.createTime[1] ? `${moment(searchFormData.createTime[1] as any * 1000).unix()}` : '', // 创建时间 结束
        crowdName: searchFormData.name,
      };
      getListData({ ...{ pageSize: pages.pageSize, pageNo: pages.pageNo }, ...searchForm });
    } catch (e) {
      // LzMsg.error(e.message);
    }
  };
  /** 搜索表单重置时触发 */
  const handleReset = (): void => {
    setSearchFormData({ createTime: [], name: '' });
    // 重置页面后 查询
    getListData();
  };

  /** 搜索表单提交时触发 */
  const handleSubmit = (val: { name: string; createTime: any }) => {
    setSearchFormData(val);
    const searchForm = {
      startTime: val.createTime.length ? new Date(`${moment(val.createTime[0]).format('YYYY-MM-DD')} 00:00:00`).getTime() : '', // 创建时间 起始
      endTime: val.createTime.length ? new Date(`${moment(val.createTime[1]).format('YYYY-MM-DD')} 23:59:59`).getTime() : '', // 创建时间 结束
      crowdName: val.name,
    };

    getListData({ ...searchForm, ...{ pageSize: pageInfo.pageSize, pageNo: 1 } });
  };

  return (
    <>
      <section>
        <Dialog
          className="hjy-crowdSelected-dialog"
          title="人群选择"
          visible={visible}
          footer={false}
          onClose={onClose}
        >
          <div>
            {/* 搜索表单 */}
            <div>
              <Form inline size="medium" value={searchFormData}>

                <FormItem label="创建时间:">
                  <RangePicker
                    popupAlign="tl tl"
                    name="createTime"
                    placeholder="请点选..."
                    style={{ width: '320px'}}
                    // showTime
                  />
                </FormItem>

                <FormItem label="人群名称:">
                  <Input
                    name="name"
                    style={{ width: 320 }}
                    placeholder="请输入..."
                    maxLength={100}
                    hasClear
                  />
                </FormItem>

                <FormItem label="">
                  <Form.Submit
                    type="primary"
                    onClick={handleSubmit}
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                  >查询
                  </Form.Submit>
                  <Form.Reset
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                    onClick={handleReset}
                    style={{ marginRight: 5 }}
                  >重置
                  </Form.Reset>
                </FormItem>
              </Form>

            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end',}}>
              {
                props?.type && <>
                  <Button text type='primary' onClick={
                    () => {
                      const url = props?.type == '4' ? '/yunLu/crowd/tag/create' : '/crowd/tag/create';
                      history.push(`../..${url}`)
                    }
                  }>新建{props?.type == '4' ? '云鹿' : ( props?.type == '1' ? '': '官方')}人群&gt;&gt;</Button>
                </>
              }
            </div>

            {/* 列表 */}
            <div>

              <div style={{ marginTop: 8 }}>
                <Table fixedHeader dataSource={dataSource} loading={isLoadingForList} columns={columns}>
                  {
                    columns.map((item: any, index: number) => {
                      return (
                        <Table.Column
                          title={item.title}
                          key={index}
                          dataIndex={item.dataIndex}
                          cell={item.cell}
                          align={item.align}
                          width={item.width}
                          alignHeader={item.alignHeader}
                          lock={item.lock}
                          htmlTitle={item.htmlTitle}
                        />
                      );
                    })
                  }
                </Table>
              </div>

              {
                !!dataSource.length &&
                <div attr-intro="分页组件" className={[style.Pagination, 'Hjy-Pagination'].join(' ')}>
                  <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
                </div>
              }
            </div>
          </div>

        </Dialog>
      </section>
    </>
  );
};

export default Dialog_CrowdSelected_List;
